<template>
  <div class="row beast-search-box">
    <div class="col-12">
      <div class="input-group">
        <div class="input-group-prepend">
            <span class="input-group-text" id="beast-search-sym">
              <font-awesome-icon :icon="search"></font-awesome-icon>
            </span>
        </div>
        <input type="text" class="form-control"
               placeholder="Search after a package name or keyword..."
               aria-describedby="beast-search-sym"
               v-model.lazy="searchQuery"
               v-on:change="emitUpdateSearchQuery">
      </div>
    </div>
  </div>
</template>

<script>
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default {
  name: "BeastSearchBox",
  props: {
    query: {
      type: String,
      default: ""
    }
  },

  watch: {
    query() {
      this.searchQuery = this.query;
    }
  },

  computed: {
    search() {
      return faSearch;
    },
  },

  data() {
    return {
      searchQuery: this.query
    };
  },

  methods: {
    emitUpdateSearchQuery() {
      this.$emit("searchEnded", this.searchQuery);
    }
  }
};
</script>

<style scoped lang="scss">
  $placeholderText: #767676;
  .beast-search-box {
    margin-bottom: 25px;

    .input-group {
      padding: 0 5px;
    }
    .input-group-text {
      background: none;
      border: none;
      color: $placeholderText;
    }
    .form-control {
      border: none;
      border-bottom: 1px solid #dbdbdb;
      border-radius: 5px;

      &:focus {
        box-shadow: 0 0 5px $beast-green;
        border: none;
      }

      &::placeholder {
        color: $placeholderText;
      }
    }
  }
</style>
